<template>
    <div>
        <div class="container_box">
            <img src="../assets/13.png" class="logo">
            <div class="list_box">
                <div class="item">
                    <img src="../assets/11.png" class="icon">
                    <input type="text" placeholder="请输入手机号码" maxlength="11" class="input_val input_phone" @input="getPhoneVal">
                </div>
            </div>
            <button class="submit_btn" @click="requestFun">绑定</button>
        </div>
    </div>
</template>



<script>
import Vue from 'vue';
import { Toast } from 'vant';
import autho from '../autho/autho.js'

Vue.use(Toast);
var that;
export default {
    data(){
        return {
            phone:'',
            code:'',
        }
    },
    mounted(){
        that = this;
        document.querySelector('body').style.background = '#fff'
    },
    methods:{
        // 绑定设备
        async requestFun(){
            if(!that.phone || that.phone.length != 11){
                Toast({message:'请输入手机号码',forbidClick:true});
                return false
            }
            const res = await autho.request('token','post','/gzhWxApiController/bindDevice',{
                    name:'',
                    phone:that.phone
                })
            autho.resetDataFun(res,function(){
                that.$router.push({path:'/'})
            })
        },
        // 监听input手机值
        getPhoneVal(e){
            that.phone = e.target.value;
        },
        // 监听input电表码
        getCodeVal(e){
            that.code = e.target.value;
        }
    }
}
</script>





<style scoped>
.logo {
	width: 1.1rem;
	height: 1.1rem;
	border-radius: 50%;
	display: block;
	margin: 1rem auto;
}
.list_box {
	padding: 0 0.3rem;
}
.item {
	border-bottom: 1px solid #ccc;
	height: 0.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.2rem;
}
.icon {
	width: 0.24rem;
	height: 0.28rem;
	margin-right: 0.1rem;
}
.input_val {
	flex: 1;
    border: none;
    outline: none;
    height: 100%;
    font-size: 0.14rem;
}
.submit_btn,.submit_btn_sure {
	display: block;
	width: 80%;
	height: 0.4rem;
	border: none;
	outline: none;
	background:#4c97fc;
	color: #fff;
	font-size: 0.16rem;
	border-radius: 0.2rem;
    margin: 0.4rem auto 0;
}


/**/
.tip_box {
	display: none;
	position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /*display: flex;*/
    justify-content: center;
    align-items: center;
}
.tip_text {
    display: inline-block;
    padding: 0.08rem 0.16rem;
    background: rgba(0,0,0,0.5);
    border-radius: 0.2rem;
    font-size: 0.14rem;
    color: #fff;
    max-width: 80%;
    min-width: 20%;
    text-align: center;
}




/*finish*/
.text {
    text-align: center;
    font-size: 0.2rem;
    color: #666;
}
</style>